import { useTheme } from "@mui/material";

const DARK_PLACEHOLDER = "/DarkMode-Placeholder.png";
const LIGHT_PLACEHOLDER = "/LightMode-Placeholder.png";

export function getOrgLogoUrl(logo) {
    if (!logo) return null;
    if (typeof logo === "string") return logo;
    return logo.processed
        ? logo.url_icon || logo.url_medium || logo.url_large || logo.url_orig
        : logo.url_orig || logo.url_icon || logo.url_medium || logo.url_large;
}

export function useOrgLogoSrc(logo) {
    const theme = useTheme();
    const url = getOrgLogoUrl(logo);
    if (url) return url;
    return theme.palette.mode === "dark" ? DARK_PLACEHOLDER : LIGHT_PLACEHOLDER;
}
